import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import uuid from 'uuid/v4';
import renderDropDownOptions from '../../../../helpers/renderDropDownOptions';


class DropDownMenu extends Component {
  constructor(props) {
    super(props);
    this.menuRef = React.createRef();
    this.iconRef = React.createRef();
    this.state = { showMenu: false, position: 'showRight' };
    this.handleBlur = this.handleBlur.bind(this);
  }

  componentDidUpdate() {
    const { showMenu } = this.state;

    if (showMenu) {
      this.checkWindowBoundaries();
    }
  }

  checkWindowBoundaries() {
    const { position } = this.state;
    const menuWidth = this.menuRef.current.offsetWidth;
    const additionalPixels = 10;
    const boundaries = this.iconRef.current.getBoundingClientRect();
    const newPosition = boundaries.left + menuWidth + additionalPixels > window.innerWidth ? 'showLeft' : 'showRight';

    if (position !== newPosition) {
      this.setState({ position: newPosition });
    }
  }

  handleSelection() {
    this.setState(prevState => ({ showMenu: !prevState.showMenu }));
  }

  handleBlur(event) {
    const { currentTarget } = event;

    setTimeout(() => {
      if (!currentTarget.contains(document.activeElement)) {
        this.setState({ showMenu: false });
      }
    }, 0);
  }

  render() {
    const {
      showMenu,
      position,
    } = this.state;

    const {
      label,
      list,
      children,
      containerClassName,
      activatedClassName,
      itemClassName,
      labelClassName,
      handleKeyPress,
    } = this.props;

    const messageClasses = classNames({
      'dropdown__menu--show': showMenu,
      'dropdown__menu--left': position === 'showLeft',
      'dropdown__menu--right': position === 'showRight',
    });
    const triggerClassNames = { [containerClassName]: true };
    const uniqueId = `dropdown-menu--${uuid()}`;

    if (activatedClassName) {
      triggerClassNames[activatedClassName] = showMenu;
    }

    const triggerClasses = classNames(triggerClassNames);

    return (
      <div className="dropdown-field__container">
        <div className={labelClassName} label={label} id={uniqueId}>
          {label}
        </div>
        <div
          tabIndex={0}
          role="listbox"
          ref={this.iconRef}
          onKeyPress={handleKeyPress || (() => this.handleSelection())}
          className={triggerClasses}
          onClick={() => this.handleSelection()}
          onBlur={this.handleBlur}
          aria-labelledby={uniqueId}
        >
          { children }
          <div className={messageClasses} ref={this.menuRef}>
            {renderDropDownOptions(itemClassName, list)}
          </div>
        </div>
      </div>
    );
  }
}

DropDownMenu.propTypes = {
  children: PropTypes.element.isRequired,
  label: PropTypes.string.isRequired,
  labelClassName: PropTypes.string,
  list: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  containerClassName: PropTypes.string,
  activatedClassName: PropTypes.string,
  itemClassName: PropTypes.string,
  handleKeyPress: PropTypes.func,
};

DropDownMenu.defaultProps = {
  containerClassName: 'dropdown-menu__toggle',
  itemClassName: 'dropdown-menu__list-item',
  labelClassName: 'number-field__input-label',
  activatedClassName: 'dropdown-menu__toggle--active',
  handleKeyPress: null,
};

export default DropDownMenu;
